import { createApp } from 'vue'
import LinksApp from './LinksApp.vue'

createApp(LinksApp).mount('#linkApp')

